'use client';

import { AnimatedLink } from '@/components/AnimatedLink';
import TrustBox from '@/components/Trustpilot/TrustBox';
import { UserReview } from '@/components/UserReview';
import { useTranslation } from '@/contexts/dictionaryContext';
import { useIsHomePage } from '@/hooks/useLocale';
import { cn } from '@/lib/utils';
import React from 'react';
import Slider from 'react-slick';
import './styles.css';
import styles from './styles.module.css';

export const Reviews: React.FC = () => {
  const {
    home: {
      review: { title, subtitle, usersReviews, cta },
    },
  } = useTranslation();
  const isHome = useIsHomePage();

  const settings = {
    dots: false,
    infinite: true,
    speed: 1500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="max-w-default mx-auto px-0 flex justify-between flex-col relative py-20">
      <div
        className={cn(
          'bg-gray-200 w-[100vw] left-1/2 -translate-x-1/2 h-full absolute top-0 z-0',
          isHome ?? 'w-[160vw]',
        )}
      />
      <div
        className={cn(
          `h-full mb-12 desktop:mb-2 center min-w-[25%] text-center relative`,
          styles['review'] ? styles['review'] : '',
        )}>
        <h2 className="w-full text-4xl font-title mb-6">
          {title}
          <br />
          {subtitle}
        </h2>

        <div className="flex gap-4 justify-center text-base">
          <TrustBox />
        </div>
      </div>

      <div className="flex justify-center pt-12 pb-8 px-6">
        <div className="relative flex flex-col justify-center w-full">
          <Slider {...settings} className="review-carousel visible w-full">
            {usersReviews.map((review, index) => (
              <UserReview
                key={index}
                className="px-[15%]"
                title={review.title}
                text={review.text}
                user={review.user}
                stars={review.stars}
              />
            ))}
          </Slider>
        </div>
      </div>

      {cta ? (
        <div className="hidden justify-center mb-6">
          <AnimatedLink
            href={cta.href}
            className="w-fit py-[20px] px-[10px] mt-[30px] desktop:px-[40px] desktop:w-fit">
            {cta.title}
          </AnimatedLink>
        </div>
      ) : null}
    </section>
  );
};
